import {ACTION_CODE} from './_actionCode';
import {TrainingObjectiveService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_TRAINING_OBJECTIVE';

export async function createTrainingObjective(
    userData: Record<string, string>,
    newTrainingObjective: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - createTrainingObjective - Start');

        const createTrainingObjectiveResult = await TrainingObjectiveService.createTrainingObjective(userData, newTrainingObjective);

        LoggerService.logInfo('Action - createTrainingObjective - End - Success');

        return ResultModel.newSuccessResult(createTrainingObjectiveResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createTrainingObjective - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
